import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';

import type { MaximizeDialogProps } from './MaximizeDialog.interface.js';
import { useStyles } from './MaximizeDialog.style.js';

export function MaximizeDialog({
  open,
  onOpenChange,
  title,
  actions,
  children,
}: MaximizeDialogProps) {
  const styles = useStyles();

  return (
    <Dialog open={open} onOpenChange={(_e, data) => onOpenChange(data.open)}>
      <DialogSurface className={styles.surface}>
        <DialogBody className={styles.body}>
          <DialogTitle>
            <div className={styles.titleRow}>
              <span>{title}</span>
              {actions}
              <DialogTrigger action="close">
                <Button
                  appearance="subtle"
                  className={styles.closeButton}
                  icon={<Dismiss24Regular />}
                  aria-label="Close"
                />
              </DialogTrigger>
            </div>
          </DialogTitle>
          <DialogContent className={styles.content}>{children}</DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
